<template>
  <div class="purchase-edit">
    <div class="card">
      <Toast />
      <div class="card-header">
        <div class="header-content">
          <h5 class="card-title" v-if="is_exist">Detail Pembelian</h5>
          <h5 class="card-title" v-else>Buat Pembelian</h5>
          <Button
            icon="pi pi-arrow-left"
            label="Kembali"
            class="p-button-text"
            @click="$router.push({ name: 'purchase-list' })"
          />
        </div>
      </div>

      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>

      <div class="card-body">
        <div class="info-grid">
          <div class="info-item">
            <label>Gudang</label>
            <div>
              <span
                v-if="
                  initial_purchase_order.warehouse_code &&
                  initial_purchase_order.warehouse_name
                "
              >
                {{ initial_purchase_order.warehouse_code }} -
                {{ initial_purchase_order.warehouse_name }}
              </span>
              <span v-else-if="initial_purchase_order.warehouse_code">
                {{ initial_purchase_order.warehouse_code }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
          <div class="info-item">
            <label>Supplier</label>
            <div>
              <span
                v-if="
                  initial_purchase_order.supplier_code &&
                  initial_purchase_order.supplier_name
                "
              >
                {{ initial_purchase_order.supplier_code }} -
                {{ initial_purchase_order.supplier_name }}
              </span>
              <span v-else-if="initial_purchase_order.supplier_code">
                {{ initial_purchase_order.supplier_code }}
              </span>
              <span v-else>-</span>
            </div>
          </div>
          <div class="info-item">
            <label>Nomor Bon</label>
            <div>{{ initial_purchase_order.doc_number }}</div>
          </div>
          <div class="info-item">
            <label>Tanggal Bon</label>
            <div>{{ initial_purchase_order.doc_date }}</div>
          </div>
          <div
            class="info-item"
            v-if="initial_purchase_order.mutation_code != ''"
          >
            <label>Kode Mutasi</label>
            <div>{{ initial_purchase_order.mutation_code }}</div>
          </div>
          <div class="info-item">
            <label>Total Barang</label>
            <div>{{ initial_purchase_order.total_item }}</div>
          </div>
          <div class="info-item">
            <label>Total Qty</label>
            <div>{{ total_qty | number }}</div>
          </div>
          <div class="info-item">
            <label>Total Harga</label>
            <div>{{ total_price | currency }}</div>
          </div>
        </div>

        <div class="table-container">
          <div
            v-if="is_exist && selectedItems.length > 0"
            class="p-mb-2"
            style="display: flex; align-items: center; gap: 0.5rem"
          >
            <Button
              label="Hapus Terpilih"
              icon="pi pi-trash"
              class="p-button-danger p-button-sm"
              :disabled="editingItemId !== null"
              @click="bulkDeleteDialogConfirmation"
            />
            <span style="font-size: 0.875rem; color: #6c757d">
              {{ selectedItems.length }} item dipilih
            </span>
          </div>
          <DataTable
            v-if="is_exist"
            :value="purchase_orders"
            :paginator="true"
            :rows="rowsPerPage"
            :rowsPerPageOptions="rowsPerPageOptionsComputed"
            :alwaysShowPaginator="false"
            responsiveLayout="scroll"
            class="p-mt-5"
            @page="onPageChange"
          >
            <Column
              v-if="initial_purchase_order.status == 0"
              :sortable="false"
              headerStyle="width: 3rem; min-width: 3rem"
              bodyStyle="width: 3rem; min-width: 3rem"
            >
              <template #header>
                <Checkbox
                  :modelValue="allItemsSelected"
                  :binary="true"
                  @change="toggleSelectAll"
                />
              </template>
              <template #body="slotProps">
                <Checkbox
                  :modelValue="isItemSelected(slotProps.data.id)"
                  :binary="true"
                  @change="toggleItemSelection(slotProps.data.id)"
                  :disabled="
                    slotProps.data.status != 0 || editingItemId !== null
                  "
                />
              </template>
            </Column>
            <Column
              field="no"
              header="No"
              :sortable="false"
              headerStyle="width: 3rem; min-width: 3rem"
              bodyStyle="width: 3rem; min-width: 3rem"
            >
              <template #body="slotProps">
                {{
                  rowsPerPage >= purchase_orders.length
                    ? slotProps.index + 1
                    : (currentPage - 1) * rowsPerPage + slotProps.index + 1
                }}
              </template>
            </Column>
            <Column
              field="item_code"
              header="Kode Barang"
              :sortable="false"
              headerStyle="width: 8rem; min-width: 8rem"
              bodyStyle="width: 8rem; min-width: 8rem"
            >
              <template #body="slotProps">
                {{ slotProps.data.item_code }}
              </template>
            </Column>
            <Column
              field="item_name"
              header="Nama Barang"
              :sortable="false"
              headerStyle="width: 12.5rem; min-width: 12.5rem"
              bodyStyle="width: 12.5rem; min-width: 12.5rem"
            >
              <template #body="slotProps">
                <template v-if="editingItemId === slotProps.data.id">
                  <InputText
                    v-model="slotProps.data.item_name"
                    class="p-inputtext-sm"
                    style="width: 100%"
                  />
                </template>
                <template v-else>
                  {{ truncateText(slotProps.data.item_name, 30) }}
                </template>
              </template>
            </Column>
            <Column
              field="category"
              header="Kategori"
              :sortable="false"
              headerStyle="width: 12.5rem; min-width: 12.5rem"
              bodyStyle="width: 12.5rem; min-width: 12.5rem"
            >
              <template #body="slotProps">
                <template v-if="editingItemId === slotProps.data.id">
                  <AutoComplete
                    placeholder="Kategori"
                    :dropdown="true"
                    v-model="slotProps.data.category_selected"
                    :suggestions="categories_filtered"
                    @complete="searchCategory($event)"
                    field="code"
                    class="p-inputtext-sm category-dropdown-zfix"
                    style="width: 100%"
                  >
                    <template #item="slotProps2">
                      <div>
                        {{ slotProps2.item.code }} - {{ slotProps2.item.name }}
                      </div>
                    </template>
                  </AutoComplete>
                </template>
                <template v-else>
                  <span
                    v-if="
                      slotProps.data.category_code ||
                      slotProps.data.category_name
                    "
                  >
                    {{
                      truncateText(
                        `${
                          slotProps.data.category_code &&
                          slotProps.data.category_code.code
                            ? slotProps.data.category_code.code
                            : slotProps.data.category_code || ''
                        }${
                          slotProps.data.category_name
                            ? ` - ${slotProps.data.category_name}`
                            : ''
                        }`,
                        20
                      )
                    }}
                  </span>
                  <span v-else class="p-text-secondary">-</span>
                </template>
              </template>
            </Column>
            <Column
              field="price"
              header="Harga Modal (Rp)"
              :sortable="false"
              headerStyle="width: 8rem; min-width: 8rem; text-align: right"
              bodyStyle="width: 8rem; min-width: 8rem; text-align: right"
            >
              <template #body="slotProps">
                <template v-if="editingItemId === slotProps.data.id">
                  <InputNumber
                    v-model="slotProps.data.price"
                    locale="id-ID"
                    class="p-inputtext-sm"
                    @input="calculateEditPrice(slotProps.data)"
                  />
                </template>
                <template v-else>
                  {{ slotProps.data.price | currency }}
                </template>
              </template>
            </Column>
            <Column
              field="qty"
              header="Qty"
              :sortable="false"
              headerStyle="width: 4rem; min-width: 4rem; text-align: right"
              bodyStyle="width: 4rem; min-width: 4rem; text-align: right"
            >
              <template #body="slotProps">
                <template v-if="editingItemId === slotProps.data.id">
                  <InputText
                    v-model="slotProps.data.qty"
                    class="p-inputtext-sm"
                    maxlength="4"
                    @input="calculateEditPrice(slotProps.data)"
                  />
                </template>
                <template v-else>
                  {{ slotProps.data.qty | number }}
                </template>
              </template>
            </Column>
            <Column
              field="total"
              header="Total Harga (Rp)"
              :sortable="false"
              headerStyle="width: 8rem; min-width: 8rem; text-align: right"
              bodyStyle="width: 8rem; min-width: 8rem; text-align: right"
            >
              <template #body="slotProps">
                {{ (slotProps.data.price * slotProps.data.qty) | currency }}
              </template>
            </Column>
            <Column
              v-if="initial_purchase_order.status != 1"
              :sortable="false"
              headerStyle="width: 6rem; min-width: 6rem"
              bodyStyle="width: 6rem; min-width: 6rem"
            >
              <template #body="slotProps">
                <template
                  v-if="
                    edit_items.find(i => i.id == slotProps.data.id) &&
                    editingItemId === slotProps.data.id
                  "
                >
                  <Button
                    icon="pi pi-check"
                    class="p-button-rounded p-button-success p-mr-2"
                    @click="saveEditForm(slotProps.data)"
                  />
                  <Button
                    icon="pi pi-times"
                    class="p-button-rounded p-button-warning"
                    @click="cancelEditForm(slotProps.data.id)"
                  />
                </template>
                <template v-else>
                  <Button
                    v-if="
                      purchase_orders.find(
                        i =>
                          i.id == slotProps.data.id &&
                          slotProps.data.status == 0
                      )
                    "
                    :disabled="editingItemId !== null"
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-success p-mr-2"
                    @click="
                      editForm(JSON.parse(JSON.stringify(slotProps.data)))
                    "
                  />
                  <Button
                    v-if="
                      purchase_orders.find(
                        i =>
                          i.id == slotProps.data.id &&
                          slotProps.data.status == 0
                      )
                    "
                    :disabled="editingItemId !== null"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-warning"
                    @click="deleteRowDialogConfirmation(slotProps.data.id)"
                  />
                </template>
              </template>
            </Column>
          </DataTable>

          <table class="table p-mt-5" v-else>
            <thead class="thead-light">
              <tr>
                <h3
                  style="position: absolute; margin-top: -0.5rem"
                  v-if="loading_fetch_data"
                >
                  MOHON TUNGGU, LOAD DATA MASIH BERLANGSUNG
                </h3>
                <th scope="col" style="width: 3rem">No</th>
                <th scope="col" style="width: 4rem">
                  <div style="display: flex; align-items: center; gap: 0.5rem">
                    <Checkbox
                      :modelValue="allAutoChecked"
                      :binary="true"
                      @change="toggleAllAuto"
                    />
                    <span>Auto</span>
                  </div>
                </th>
                <th scope="col" style="width: 4rem">
                  <div style="display: flex; align-items: center; gap: 0.5rem">
                    <Checkbox
                      :modelValue="allBaruChecked"
                      :binary="true"
                      @change="toggleAllBaru"
                    />
                    <span>Baru</span>
                  </div>
                </th>
                <th scope="col" style="width: 10rem">Manual</th>
                <th scope="col" style="width: 12rem">Item</th>
                <th scope="col" style="width: 10rem">Kategori</th>
                <th scope="col" style="width: 20rem">Nama</th>
                <th scope="col" style="width: 8rem">HM (Rp)</th>
                <th scope="col" style="width: 4rem">Qty</th>
                <th scope="col" style="width: 8rem">Total (Rp)</th>
                <th scope="col" style="width: 4rem"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(purchase_order, k) in form_data" :key="k">
                <td>{{ k + 1 }}</td>
                <td>
                  <Checkbox
                    v-model="purchase_order.generate_code"
                    :binary="true"
                    @change="handleAutoChange(k)"
                  />
                </td>
                <td>
                  <Checkbox
                    v-model="purchase_order.is_new"
                    :binary="true"
                    @change="handleBaruChange(k)"
                  />
                </td>
                <td>
                  <InputText
                    v-model="purchase_order.manual"
                    placeholder="Kode Manual"
                    @keyup.prevent="onManualCodeChange(k)"
                    :disabled="
                      purchase_order.generate_code || !purchase_order.is_new
                    "
                    ref="column1Ref"
                    style="width: 10rem"
                  />
                  <small class="p-error" v-if="is_error.items[k].manual">{{
                    error_msg.items[k].manual
                  }}</small>
                </td>
                <td>
                  <AutoComplete
                    placeholder="Item"
                    :dropdown="true"
                    v-model="purchase_order.item_selected"
                    :suggestions="items"
                    @complete="getItems(k)"
                    @item-select="onItemSelect(k)"
                    @change="validateItemCode(k)"
                    field="code"
                    :disabled="
                      purchase_order.is_new || purchase_order.generate_code
                    "
                    class="item-autocomplete"
                  />
                  <small class="p-error" v-if="is_error.items[k].code">{{
                    error_msg.items[k].code
                  }}</small>
                </td>
                <td v-if="purchase_order.generate_code" ref="column2">
                  <AutoComplete
                    placeholder="Kategori"
                    :dropdown="true"
                    v-model="purchase_order.category_selected"
                    :suggestions="categories_filtered"
                    @complete="searchCategory($event)"
                    field="code"
                    :disabled="purchase_order.generate_category"
                    ref="column2Ref"
                    class="category-autocomplete"
                  >
                    <template #item="slotProps">
                      <div>
                        {{ slotProps.item.code }} - {{ slotProps.item.name }}
                      </div>
                    </template>
                    <template #input>
                      <input :tabindex="1" />
                    </template>
                  </AutoComplete>
                  <small
                    class="p-error"
                    v-if="!purchase_order.category_selected"
                    >{{ error_msg.items[k].cat_id }}</small
                  >
                </td>
                <td v-else ref="column3">
                  <AutoComplete
                    placeholder="Kategori"
                    :dropdown="true"
                    v-model="purchase_order.category_selected"
                    :suggestions="categories_filtered"
                    @complete="searchCategory($event)"
                    field="code"
                    :disabled="purchase_order.generate_category"
                    refs="column3Ref"
                    class="category-autocomplete"
                  >
                    <template #item="slotProps">
                      <div>
                        {{ slotProps.item.code }} - {{ slotProps.item.name }}
                      </div>
                    </template>
                  </AutoComplete>
                  <small
                    class="p-error"
                    v-if="!purchase_order.category_selected"
                    >{{ error_msg.items[k].cat_id }}</small
                  >
                </td>
                <td ref="column2">
                  <InputText
                    v-model="purchase_order.name"
                    placeholder="Nama"
                    @keyup.prevent="is_error.doc_number = false"
                    :disabled="!purchase_order.is_new"
                    ref="column4Ref"
                    spellcheck="false"
                    style="width: 20rem"
                  />
                  <small class="p-error" v-if="is_error.items[k].name">{{
                    error_msg.items[k].name
                  }}</small>
                </td>
                <td ref="column3">
                  <InputNumber
                    locale="id-ID"
                    v-model="purchase_order.price"
                    :id="'price-' + k"
                    placeholder="0"
                    @input="calculatePrice(k)"
                    ref="column5Ref"
                    style="width: 7rem"
                  />
                  <small class="p-error" v-if="is_error.items[k].price">{{
                    error_msg.items[k].price
                  }}</small>
                </td>
                <td ref="column4">
                  <InputText
                    v-model="purchase_order.qty"
                    placeholder="0"
                    maxlength="4"
                    @input="calculatePrice(k)"
                    ref="column6Ref"
                    style="width: 4rem"
                  />
                  <small class="p-error" v-if="is_error.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td>
                  <InputNumber
                    locale="id-ID"
                    v-model="purchase_order.total_price"
                    placeholder="0"
                    :disabled="true"
                    style="width: 8rem"
                  />
                </td>
                <td>
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label for="">Total</label>
                </td>
                <td>
                  <InputNumber
                    v-model="totalQuantity"
                    :disabled="true"
                    style="width: 4rem"
                  />
                </td>
                <td>
                  <InputNumber
                    v-model="totalPrice"
                    locale="id-ID"
                    :disabled="true"
                  />
                </td>
                <td>
                  <Button icon="pi pi-plus" class="p-mr-2" @click="addRow()" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div
          class="p-grid p-fluid p-jc-center p-ai-center"
          v-if="is_exist == false"
        >
          <div class="p-col-12 p-md-4 p-lg-4 p-d-flex p-ai-center">
            <Checkbox
              :modelValue="create_data.confirmed"
              :binary="true"
              inputId="confirm-enough-qty"
              @change="create_data.confirmed = !create_data.confirmed"
            />
            <label for="confirm-enough-qty" class="p-ml-2">
              Apakah total qty sudah sesuai?
            </label>
          </div>
        </div>

        <div class="p-grid p-fluid p-jc-center">
          <div class="p-col-12 p-md-4 p-lg-4">
            <button
              type="button"
              class="btn btn-primary"
              :class="{ 'btn-loading': loading }"
              style="width: 100%"
              @click="submit()"
              :disabled="loading || !isFormValid || !create_data.confirmed"
              v-if="is_exist == false"
            >
              Simpan
              <span v-if="loading" class="spinner">
                <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
              </span>
            </button>
          </div>
        </div>

        <div class="p-grid p-fluid p-jc-end">
          <div class="p-col-12 p-md-3 p-lg-2">
            <Button
              v-if="
                this.initial_purchase_order.status != 0 &&
                user.role === 'PURCHASING'
              "
              label="Hapus"
              icon="pi pi-trash"
              class="p-button-warning p-button-sm"
              @click="deletePurchaseOrderDialog()"
            />
          </div>

          <div
            class="p-col-12 p-md-3 p-lg-2"
            v-if="
              is_exist &&
              status != true &&
              this.initial_purchase_order.status == 0 &&
              edit_items.length == 0 &&
              user.role === 'PURCHASING'
            "
          >
            <Button
              label="Generate"
              icon="pi pi-refresh"
              class="p-button-info p-button-sm"
              @click="create_dialog = true"
            />
          </div>

          <div class="p-col-12 p-md-3 p-lg-2">
            <router-link
              :to="{
                name: 'print-purchasing',
                query: {
                  warehouse_id: user.warehouse_id,
                  init_id: initial_purchase_order.id,
                  doc_number: initial_purchase_order.doc_number,
                  start_date: initial_purchase_order.doc_date,
                  mutation_code: initial_purchase_order.mutation_code,
                  supplier_code: initial_purchase_order.supplier_code
                }
              }"
              target="_blank"
            >
              <Button
                label="Print"
                icon="pi pi-print"
                class="p-button-primary p-button-sm"
                v-if="
                  this.initial_purchase_order.status != 0 &&
                  user.role === 'PURCHASING'
                "
              />
            </router-link>
          </div>
        </div>

        <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
          <Dialog
            :visible.sync="generate_dialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Hapus"
            :modal="true"
          >
            <div class="confirmation-content">
              <i class="pi pi-info-circle p-mr-2" style="font-size: 1rem" />
              <span>Anda yakin ingin menghapus daftar pembelian ini? </span>
            </div>
            <template #footer>
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="generate_dialog = falsem"
              />
              <Button
                label="Hapus"
                icon="pi pi-check"
                class="p-button-text"
                @click="deletePurchaseOrder()"
              />
            </template>
          </Dialog>
        </div>

        <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
          <Dialog
            :visible.sync="deleteRowDialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Hapus Baris"
            :modal="true"
          >
            <div class="confirmation-content">
              <i class="pi pi-info-circle p-mr-2" style="font-size: 1rem" />
              <span>Anda yakin ingin menghapus item ini? </span>
            </div>
            <template #footer>
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteRowDialog = false"
              />
              <Button
                label="Hapus"
                icon="pi pi-check"
                class="p-button-text"
                @click="deletePerRow()"
              />
            </template>
          </Dialog>
        </div>

        <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
          <Dialog
            :visible.sync="bulkDeleteDialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Hapus Item Terpilih"
            :modal="true"
          >
            <div class="confirmation-content">
              <i class="pi pi-info-circle p-mr-2" style="font-size: 1rem" />
              <span
                >Anda yakin ingin menghapus
                <strong>{{ selectedItems.length }}</strong> item terpilih?
              </span>
            </div>
            <template #footer>
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-text"
                @click="bulkDeleteDialog = false"
              />
              <Button
                label="Hapus"
                icon="pi pi-check"
                class="p-button-text p-button-danger"
                @click="bulkDeleteItems()"
                :disabled="loading"
              >
                <span v-if="loading">
                  <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
                </span>
              </Button>
            </template>
          </Dialog>
        </div>

        <div class="p-col-header p-sm-12 p-md-6 p-lg-2">
          <Dialog
            :visible.sync="create_dialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Generate"
            :modal="true"
          >
            <div class="confirmation-content" v-if="enough_status == 1">
              <i class="pi pi-info-circle p-mr-2" style="font-size: 1rem" />
              Anda yakin ingin men generate bon ini
              <strong>{{ this.initial_purchase_order.doc_number }}</strong> ?
            </div>
            <div class="confirmation-content" v-else>
              <i
                class="pi pi-exclamation-triangle p-mr-2"
                style="font-size: 1rem; color: #f0ad4e"
              />
              Breakdown pembelian ini belum dikonfirmasi ("Apakah total qty
              sudah sesuai?" belum dicentang saat simpan). Generate belum bisa
              dilakukan sampai breakdown disimpan ulang dengan konfirmasi
              tersebut.
            </div>
            <template #footer>
              <div class="flexp-d-flex p-js-between p-p-1">
                <button
                  type="button"
                  label="Cancel"
                  icon="pi pi-times"
                  class="btn btn-danger p-p-3"
                  @click="create_dialog = false"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  icon="pi pi-check"
                  class="btn btn-primary p-p-3"
                  @click="generate()"
                  :disabled="loading || enough_status != 1"
                >
                  Simpan
                  <span v-if="loading">
                    <i
                      class="pi pi-spin pi-spinner"
                      style="font-size: 12px"
                    ></i>
                  </span>
                </button>
              </div>
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated']),

    // Computed property for pagination options including "All"
    rowsPerPageOptionsComputed() {
      const options = [10, 20]
      // Add "All" option with total records count if we have data
      if (this.purchase_orders && this.purchase_orders.length > 20) {
        options.push(this.purchase_orders.length)
      }
      return options
    },

    // Convert price calculations to computed properties
    totalPrice() {
      return this.form_data.reduce((total, item) => {
        const price = parseInt(item.price) || 0
        const qty = parseInt(item.qty) || 0
        return total + price * qty
      }, 0)
    },

    totalQuantity() {
      return this.form_data.reduce((total, item) => {
        const qty = parseInt(item.qty) || 0
        return total + qty
      }, 0)
    },

    // Computed property for edit mode total price
    editModeTotalPrice() {
      return this.purchase_orders.reduce((total, item) => {
        const price = parseInt(item.price) || 0
        const qty = parseInt(item.qty) || 0
        return total + price * qty
      }, 0)
    },

    // Computed property for edit mode total quantity
    editModeTotalQuantity() {
      return this.purchase_orders.reduce((total, item) => {
        const qty = parseInt(item.qty) || 0
        return total + qty
      }, 0)
    },

    // Computed property for form validation
    isFormValid() {
      return this.form_data.every(item => {
        return item.name && item.qty && item.price
      })
    },

    // Computed property for "Check All" Auto column
    allAutoChecked() {
      if (!this.form_data || this.form_data.length === 0) {
        return false
      }
      return this.form_data.every(item => item.generate_code === true)
    },

    // Computed property for "Check All" Baru column
    allBaruChecked() {
      if (!this.form_data || this.form_data.length === 0) {
        return false
      }
      return this.form_data.every(item => item.is_new === true)
    },

    // Manual item_codes that appear more than once among Baru rows with
    // Auto unchecked (the only rows where `manual` is a user-authored
    // code that could actually collide). Comparison is case-sensitive
    // and trim-only to match the DB's `UNIQUE(code)` constraint on
    // master_item, which is a plain btree with no case folding.
    // A memoized Set here (rather than a per-row nested scan) keeps a
    // bulk "check all Baru" toggle across many rows from becoming
    // quadratic.
    duplicateManualCodes() {
      const counts = {}
      this.form_data.forEach(item => {
        if (!item.is_new || item.generate_code || !item.manual) {
          return
        }
        const code = item.manual.trim()
        if (!code) {
          return
        }
        counts[code] = (counts[code] || 0) + 1
      })
      return new Set(Object.keys(counts).filter(code => counts[code] > 1))
    }
  },
  data() {
    return {
      items: [],
      categories: [],
      categories_filtered: [],
      initial_purchase_order: {},
      init_form_length: 0,
      purchase_orders: [],

      loading: false,
      loading_fetch_data: true,
      is_exist: true,
      status: true,
      total_price: 0,
      total_qty: 0,
      total: 0,
      enough_status: 0,

      // Pagination tracking for continuous numbering
      currentPage: 1,
      rowsPerPage: 10,

      form_edit: 0,
      edit_form_id: 0,
      row_after: 0,

      create_dialog: false,
      generate_dialog: false,
      deleteRowDialog: false,

      deleteItemId: null,

      form_data: [
        {
          generate_code: true,
          generate_category: false,
          item_selected: null,
          is_new: true,
          category_selected: null,
          name: '',
          qty: null,
          price: 0,
          total_price: null,
          manual: null
        }
      ],
      itemsToAdd: [], // Menyimpan item yang akan ditambahkan
      addingInProgress: false, // Status apakah penambahan sedang berlangsung
      throttleInterval: 1000, // Interval dalam milidetik (1 detik)
      maxItemsPerInterval: 50, // Maksimal item per detik

      edit_items: [],
      editingItemId: null,
      selectedItems: [],
      bulkDeleteDialog: false,

      // Pending debounced catalog-duplicate check timers, keyed by
      // form_data row index. Cleared per-row when a newer edit
      // supersedes one, and cleared entirely by deleteRow() since
      // splice() shifts indices out from under any pending timer.
      catalogCheckTimers: {},

      create_data: {
        init_id: 0,
        doc_number: '',
        doc_date: '',
        sup_id: 0,
        confirmed: false,
        items: [
          {
            is_new: true,
            code: '',
            cat_id: 0,
            name: '',
            qty: null,
            price: 0
          }
        ]
      },

      is_error: {
        items: [
          {
            code: false,
            cat_id: false,
            name: false,
            qty: false,
            price: false,
            manual: false
          }
        ]
      },

      error_msg: {
        items: [
          {
            code: '',
            cat_id: '',
            name: '',
            qty: '',
            price: '',
            manual: ''
          }
        ]
      }
    }
  },
  mounted() {
    this.getAuthUser()
    this.getInitialPurchaseOrder()
    this.getPurchaseOrders()
    this.getCategories()
  },

  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    // Handle pagination change for continuous numbering
    onPageChange(event) {
      // PrimeVue page event structure:
      // { page: 0-based page number, first: index of first record, rows: rows per page }
      this.currentPage = event.page + 1 // Convert 0-based to 1-based
      this.rowsPerPage = event.rows
    },

    prepareItemsToAdd() {
      // Siapkan data untuk ditambahkan ke form_data
      this.itemsToAdd = []
      for (let i = 1; i < this.init_form_length; i++) {
        this.itemsToAdd.push({
          generate_code: true,
          generate_category: false,
          item_selected: null,
          is_new: true,
          category_selected: null,
          name: '',
          qty: null,
          price: null,
          total_price: null,
          manual: null
        })

        this.error_msg.items.push({
          code: '',
          cat_id: '',
          name: '',
          qty: '',
          price: '',
          manual: ''
        })

        this.is_error.items.push({
          code: false,
          cat_id: false,
          name: false,
          qty: false,
          price: false,
          manual: false
        })
      }
    },

    addItemsToFormData() {
      if (this.addingInProgress) return // Hindari eksekusi jika sudah ada proses yang berlangsung

      this.addingInProgress = true

      const addItems = () => {
        const itemsToAddNow = this.itemsToAdd.splice(
          0,
          this.maxItemsPerInterval
        )
        this.form_data.push(...itemsToAddNow)

        if (this.itemsToAdd.length > 0) {
          setTimeout(addItems, this.throttleInterval) // Lanjutkan penambahan setelah interval
        } else {
          this.addingInProgress = false // Selesai menambahkan semua item
          this.loading_fetch_data = false
        }
      }

      addItems() // Mulai proses penambahan item
    },

    async getItems(index) {
      let code = ''
      if (index !== undefined) {
        code =
          this.form_data[index].item_selected instanceof Object
            ? this.form_data[index].item_selected.code
            : this.form_data[index].item_selected
            ? this.form_data[index].item_selected
            : ''
      }

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=5&show_empty_stock=true`
        )

        if (response.status === 200) {
          try {
            if (response.data.data.items.length == 0) {
              this.showToast('error', 'Error', 'Stok barang sudah habis')
              this.items = []
              return
            } else {
              this.items = response.data.data.items
            }
          } catch (error) {
            console.error('Error processing items:', error)
            this.items = response.data.data.items
            return
          }
        }
      } catch (error) {
        console.error('Error fetching items:', error)
      }
    },

    moveToNextColumn(nextColumn) {
      const refName = `column${nextColumn}Ref`
      const columnRef = this.$refs[refName]

      if (columnRef) {
        const inputElement = columnRef.$el || columnRef // handle if ref is a component or an element

        if (
          inputElement instanceof HTMLElement &&
          typeof inputElement.focus === 'function'
        ) {
          inputElement.focus()
        } else {
          console.error(`Ref "${refName}" is not a valid focusable element.`)
        }
      } else {
        console.error(`Ref "${refName}" not found.`)
      }
    },

    addRowAfterEnough() {
      this.row_after = 1
    },

    deleteRowAfterEnough() {
      this.row_after = 0
    },

    onItemSelect(index) {
      const item = this.form_data[index]
      if (item.item_selected && item.item_selected.id) {
        // Only update fields when an item is actually selected
        item.is_new = false
        item.generate_category = true
        item.category_selected = {
          id: item.item_selected.cat_id,
          code: item.item_selected.cat_code
        }
        item.name = item.item_selected.name
        // Set price directly from cap_price
        const capPrice = item.item_selected.cap_price
        item.price = capPrice ? Number(capPrice) : 0
        // Force price update in the InputNumber component
        this.$nextTick(() => {
          this.calculatePrice(index)
        })
      }
    },

    async saveEditForm(item) {
      // Extract category data from category_selected or fallback to category_code
      let catCode = ''
      let catId = 0

      if (item.category_selected) {
        catCode = item.category_selected.code
        catId = item.category_selected.id
      } else if (item.category_code) {
        if (typeof item.category_code === 'object' && item.category_code.code) {
          catCode = item.category_code.code
          catId = item.category_code.id
        } else if (typeof item.category_code === 'string') {
          catCode = item.category_code
          const foundCategory = this.categories.find(
            i => i.code === item.category_code
          )
          catId = foundCategory ? foundCategory.id : 0
        }
      }

      var saveForm = {
        manual: item.item_code,
        is_new: true,
        code: catCode,
        cat_id: catId,
        name: item.item_name,
        qty: parseInt(item.qty),
        price: parseInt(item.price)
      }

      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/update?id=${item.id}`,
          saveForm
        )

        if (response.status === 200) {
          let item_index = this.edit_items.findIndex(o => o.id == item.id)
          if (item_index != -1) {
            this.edit_items.splice(item_index, 1)
          }
          this.getPurchaseOrders()
          this.calculateEditPrice()
          this.editingItemId = null
          // Clear selection after successful save
          this.clearSelection()
          this.showToast('success', 'Berhasil', 'Berhasil Edit Item')
        }
      } catch (error) {
        console.error('Error updating purchase order:', error)
        this.showToast('error', 'Gagal', 'Gagal Edit Item')
      }
    },

    cancelEditForm(id, index) {
      let item_index = this.edit_items.findIndex(o => o.id == id)
      this.editingItemId = null
      this.purchase_orders[index] = JSON.parse(
        JSON.stringify(this.edit_items[item_index])
      )
      if (item_index != -1) {
        this.edit_items.splice(item_index, 1)
        this.getPurchaseOrders()
      }
      // Clear selection when canceling edit
      this.clearSelection()
    },

    async getCategories() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/categories`
        )

        if (response.status === 200) {
          this.categories = response.data.data.categories.map(item => {
            return {
              alias: `${item.code} - ${item.name}`,
              code: item.code,
              id: item.id,
              name: item.name,
              parent: item.parent
            }
          })
        }
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
    },

    searchCategory(event) {
      try {
        this.categories_filtered = this.categories.filter(item => {
          return (
            item.code.toLowerCase().startsWith(event.query.toLowerCase()) ||
            item.name.toLowerCase().startsWith(event.query.toLowerCase())
          )
        })
      } catch (error) {
        this.showToast('error', 'Error', 'Kode Kategori tidak ditemukan')
        this.categories_filtered = []
        return
      }
    },

    async getInitialPurchaseOrder() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/initial-purchase-orders/${this.$route.query.id}`
        )

        if (response.status === 200) {
          this.initial_purchase_order =
            response.data.data.initial_purchase_order
        }

        this.init_form_length = this.initial_purchase_order.total_item
        this.enough_status = this.initial_purchase_order.enough

        this.prepareItemsToAdd()
        this.addItemsToFormData()
      } catch (error) {
        console.error('Error fetching initial purchase order:', error)
      }
    },

    async generate() {
      this.loading = true
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/generate?init_id=${this.initial_purchase_order.id}`
        )
        if (response.status === 200) {
          this.create_dialog = false
          this.showToast('success', 'Berhasil', 'Generate Pembelian')
          this.initial_purchase_order.status = 1
          await this.getPurchaseOrders()
          await this.getInitialPurchaseOrder()
        } else {
          this.showToast('error', 'Gagal', 'Generate Pembelian')
        }
      } catch (error) {
        this.showToast('error', 'Gagal', 'Generate Pembelian')
      } finally {
        this.loading = false
        this.create_dialog = false
      }
    },

    generateDialogConfirmation() {
      this.create_dialog = true
    },

    async getPurchaseOrders() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders?init_id=${this.$route.query.id}`
        )

        if (response.status === 200) {
          this.total_qty = 0
          this.total_price = 0
          this.purchase_orders = response.data.data.purchase_orders
          this.is_exist = this.purchase_orders.length > 0

          this.purchase_orders.forEach(item => {
            this.total_qty += parseInt(item.qty)
            this.total_price += parseInt(item.price) * parseInt(item.qty)
          })

          for (const order of this.purchase_orders) {
            if (order.status === 0) {
              this.status = false
              break // Keluar dari loop jika ditemukan status 0
            }
          }
        }
      } catch (error) {
        console.error('Error fetching purchase orders:', error)
      }
    },

    deletePurchaseOrderDialog() {
      this.generate_dialog = true
    },

    deleteRowDialogConfirmation(id) {
      this.deleteItemId = id
      this.deleteRowDialog = true
    },

    async deletePerRow() {
      const id = this.deleteItemId
      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/item/${id}`
        )

        if (response.status === 200) {
          this.deleteRowDialog = false
          this.showToast('success', 'Berhasil', 'Berhasil Hapus Item')
          this.getPurchaseOrders()
          this.getInitialPurchaseOrder()
        } else {
          this.showToast('error', 'Gagal', 'Gagal Hapus Item')
        }
      } catch (error) {
        console.error('Error deleting item:', error)
        this.showToast('error', 'Gagal', 'Gagal Hapus Item')
      } finally {
        this.generate_dialog = false
      }
    },

    async deletePurchaseOrder() {
      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders?init_id=${this.$route.query.id}`
        )

        if (response.status === 200) {
          this.showToast('success', 'Berhasil', 'Berhasil Hapus Pembelian')
          this.clearData()
          // set button print not show again
          this.initial_purchase_order.status = 0
          this.getPurchaseOrders()
        } else {
          this.showToast('error', 'Gagal', 'Gagal Hapus Pembelian')
          this.getPurchaseOrders()
        }
      } catch (error) {
        console.error('Error deleting purchase order:', error)
        this.showToast('error', 'Gagal', 'Gagal Hapus Pembelian')
        this.getPurchaseOrders()
      } finally {
        this.generate_dialog = false
      }
    },

    editForm(item) {
      this.editingItemId = item.id
      // Clear selection when entering edit mode
      this.selectedItems = []
      let temp = JSON.parse(JSON.stringify(item))

      // Normalize category data for dropdown
      if (temp.category_code) {
        if (typeof temp.category_code === 'object' && temp.category_code.code) {
          // Already an object with code property
          temp.category_selected = this.categories.find(
            cat => cat.code === temp.category_code.code
          ) || {
            id: temp.category_code.id,
            code: temp.category_code.code,
            name: temp.category_name || '',
            alias: `${temp.category_code.code} - ${temp.category_name || ''}`
          }
        } else if (typeof temp.category_code === 'string') {
          // String format, find in categories
          temp.category_selected =
            this.categories.find(cat => cat.code === temp.category_code) || null
        } else {
          temp.category_selected = null
        }
      } else {
        temp.category_selected = null
      }

      this.edit_items.push(temp)
      return {
        alias: `${item.code} - ${item.name}`
      }
    },

    async submit() {
      if (await this.validateForm()) {
        this.loading = true
        this.create_data.init_id = this.initial_purchase_order.id
        this.create_data.sup_id = this.initial_purchase_order.supplier_id
        this.create_data.doc_number = this.initial_purchase_order.doc_number
        this.create_data.doc_date = this.initial_purchase_order.doc_date

        // Mengubah form_data menjadi array item
        const items = this.form_data.map(item => {
          let code = ''
          if (item.item_selected) {
            code = item.item_selected.code
              ? item.item_selected.code
              : item.item_selected
          }
          return {
            is_new: item.is_new,
            code: code,
            cat_id: item.category_selected.id,
            name: item.name.toUpperCase(),
            qty: parseInt(item.qty),
            price: parseInt(item.price),
            manual: item.manual
          }
        })

        // Fungsi untuk mengirim batch
        const sendBatch = async batch => {
          try {
            const response = await this.$http.post(
              `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders`,
              {
                ...this.create_data,
                items: batch
              }
            )

            if (response.status === 200) {
              console.info('Batch successfully sent')
            } else {
              console.error('Failed to send batch')
              this.showToast('error', 'Gagal', 'Gagal simpan pembelian')
            }
          } catch (error) {
            console.error('Error sending batch:', error)
            this.showToast('error', 'Gagal', 'Gagal simpan pembelian')
          }
        }

        // Mengirim data dalam batch
        const batchSize = 100
        const delay = 1000 // 1 detik
        for (let i = 0; i < items.length; i += batchSize) {
          const batch = items.slice(i, i + batchSize)
          await sendBatch(batch)
          await new Promise(resolve => setTimeout(resolve, delay)) // Tunggu sebelum mengirim batch berikutnya
        }

        // Mengatur status dan mengambil data ulang setelah pengiriman selesai
        this.showToast('success', 'Berhasil', 'Berhasil ubah pembelian')
        await this.getInitialPurchaseOrder()
        this.clearData()
        await this.getPurchaseOrders()

        this.loading = false
      }
    },

    validateItemCode(index) {
      const item = this.form_data[index]
      let valid = true

      // Reset error states
      this.is_error.items[index].code = false
      this.is_error.items[index].manual = false
      this.error_msg.items[index].code = ''
      this.error_msg.items[index].manual = ''

      // Re-check every Baru+manual row's in-form duplicate status, not
      // just this one: a code change on this row can resolve — or
      // create — a clash with a sibling row that nothing else would
      // re-validate.
      this.syncDuplicateManualErrors()

      // Condition 1: generate_code true and new_item true
      if (item.generate_code && item.is_new) {
        // Default condition - no validation needed
        return true
      }

      // Condition 2: generate_code false and new_item true
      if (!item.generate_code && item.is_new) {
        if (!item.manual) {
          valid = false
          this.is_error.items[index].manual = true
          this.error_msg.items[index].manual = 'Kode manual harus diisi'
        } else if (this.is_error.items[index].manual) {
          // syncDuplicateManualErrors() above already flagged this row
          valid = false
        }
        // Item dropdown not required
      }

      // Condition 3: generate_code true and new_item false
      if (item.generate_code && !item.is_new) {
        // Same as default condition - no validation needed
        return true
      }

      // Condition 4: generate_code false and new_item false
      if (!item.generate_code && !item.is_new) {
        if (!item.item_selected) {
          valid = false
          this.is_error.items[index].code = true
          this.error_msg.items[index].code = 'Pilih item'
        }
      }

      return valid
    },

    // Applies duplicateManualCodes to every Baru+manual row, not just the
    // one that just changed. Only ever sets/clears the specific
    // in-form-duplicate message it owns — never touches a required-field
    // or catalog-duplicate error that another check is responsible for.
    syncDuplicateManualErrors() {
      const DUPLICATE_MSG = 'Kode ini dipakai di baris lain'

      this.form_data.forEach((row, i) => {
        if (!row.is_new || row.generate_code || !row.manual) {
          return
        }

        if (this.duplicateManualCodes.has(row.manual.trim())) {
          this.is_error.items[i].manual = true
          this.error_msg.items[i].manual = DUPLICATE_MSG
        } else if (this.error_msg.items[i].manual === DUPLICATE_MSG) {
          this.is_error.items[i].manual = false
          this.error_msg.items[i].manual = ''
        }
      })
    },

    // Catalog-duplicate check (Task 3). GET /warehouse-items?code= does
    // a case-insensitive PREFIX match (`mi.code ILIKE {code}%`) — built
    // for the item autocomplete, not an existence check — so a "hit"
    // only counts once narrowed to an exact, case-sensitive match on
    // the returned `code` field. `limit=10` is a decided stopgap: it
    // doesn't fully close the risk of the real exact match being pushed
    // past the returned page by other same-prefix codes (see
    // tasks/plan.md), but the DB's UNIQUE(code) constraint remains the
    // hard backstop if that happens.
    async runCatalogCheck(index) {
      const item = this.form_data[index]
      if (!item || !item.is_new || item.generate_code) {
        return
      }

      const code = (item.manual || '').trim()
      if (!code) {
        return
      }

      // Required-field and in-form-duplicate checks outrank this one —
      // never overwrite either.
      if (this.is_error.items[index].manual) {
        return
      }

      let response
      try {
        response = await this.$http.get(
          `${
            process.env.VUE_APP_API_URL
          }/warehouse-items?code=${encodeURIComponent(
            code
          )}&limit=10&show_empty_stock=true`
        )
      } catch (error) {
        console.error('Error checking catalog for duplicate item_code:', error)
        return
      }

      // Stale-response guard: discard this result if the row's code (or
      // its error state) changed while the request was in flight.
      const current = this.form_data[index]
      if (
        !current ||
        (current.manual || '').trim() !== code ||
        this.is_error.items[index].manual
      ) {
        return
      }

      const items =
        (response &&
          response.data &&
          response.data.data &&
          response.data.data.items) ||
        []
      const exists = items.some(catalogItem => catalogItem.code === code)

      if (exists) {
        this.is_error.items[index].manual = true
        this.error_msg.items[index].manual =
          'Kode sudah dipakai item lain di katalog'
      }
    },

    // Debounces runCatalogCheck (~400ms) so it fires once typing pauses
    // rather than on every keystroke. Keyed per row so typing in one
    // row never cancels or delays another row's pending check.
    scheduleCatalogCheck(index) {
      if (this.catalogCheckTimers[index]) {
        clearTimeout(this.catalogCheckTimers[index])
      }
      this.catalogCheckTimers[index] = setTimeout(() => {
        delete this.catalogCheckTimers[index]
        this.runCatalogCheck(index)
      }, 400)
    },

    // Bound to the Manual input's keyup, alongside the existing
    // synchronous validateItemCode() call.
    onManualCodeChange(index) {
      this.validateItemCode(index)
      this.scheduleCatalogCheck(index)
    },

    handleAutoChange(index) {
      const item = this.form_data[index]
      if (item.generate_code) {
        // When auto is checked, clear and disable manual input
        item.manual = null
      }
      // Validate after change
      this.validateItemCode(index)
    },

    handleBaruChange(index) {
      const item = this.form_data[index]
      if (item.is_new) {
        // When baru is checked, clear item selection
        item.item_selected = null
      } else {
        // When baru is unchecked, clear manual code if auto is checked
        if (item.generate_code) {
          item.manual = null
          item.item_selected = null
        }
      }
      // Validate after change
      this.validateItemCode(index)
    },

    toggleAllAuto() {
      const shouldCheckAll = !this.allAutoChecked
      this.form_data.forEach((item, index) => {
        item.generate_code = shouldCheckAll
        // Call handleAutoChange to maintain existing logic
        this.handleAutoChange(index)
      })
    },

    toggleAllBaru() {
      const shouldCheckAll = !this.allBaruChecked
      this.form_data.forEach((item, index) => {
        item.is_new = shouldCheckAll
        // Call handleBaruChange to maintain existing logic
        this.handleBaruChange(index)
      })
    },

    // Bulk selection methods
    toggleSelectAll() {
      const shouldSelectAll = !this.allItemsSelected
      // Only select/deselect items with status 0 (editable)
      this.purchase_orders.forEach(item => {
        if (item.status === 0) {
          if (shouldSelectAll) {
            if (!this.selectedItems.includes(item.id)) {
              this.selectedItems.push(item.id)
            }
          } else {
            const index = this.selectedItems.indexOf(item.id)
            if (index > -1) {
              this.selectedItems.splice(index, 1)
            }
          }
        }
      })
    },

    toggleItemSelection(itemId) {
      const index = this.selectedItems.indexOf(itemId)
      if (index > -1) {
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push(itemId)
      }
    },

    isItemSelected(itemId) {
      return this.selectedItems.includes(itemId)
    },

    clearSelection() {
      this.selectedItems = []
    },

    bulkDeleteDialogConfirmation() {
      if (this.selectedItems.length === 0) {
        this.showToast('warn', 'Peringatan', 'Pilih item yang akan dihapus')
        return
      }
      this.bulkDeleteDialog = true
    },

    async bulkDeleteItems() {
      if (this.selectedItems.length === 0) {
        this.bulkDeleteDialog = false
        return
      }

      this.loading = true
      const itemsToDelete = [...this.selectedItems]
      let successCount = 0
      let failCount = 0

      try {
        // Delete items sequentially
        for (const itemId of itemsToDelete) {
          try {
            const response = await this.$http.delete(
              `${process.env.VUE_APP_API_URL}/dashboard/purchase-orders/item/${itemId}`
            )

            if (response.status === 200) {
              successCount++
            } else {
              failCount++
            }
          } catch (error) {
            console.error(`Error deleting item ${itemId}:`, error)
            failCount++
          }
        }

        // Show results
        if (successCount > 0) {
          this.showToast(
            'success',
            'Berhasil',
            `Berhasil menghapus ${successCount} item`
          )
        }
        if (failCount > 0) {
          this.showToast(
            'warn',
            'Peringatan',
            `${failCount} item gagal dihapus`
          )
        }

        // Refresh data
        await this.getPurchaseOrders()
        await this.getInitialPurchaseOrder()

        // Clear selection
        this.clearSelection()
      } catch (error) {
        console.error('Error in bulk delete:', error)
        this.showToast('error', 'Gagal', 'Terjadi kesalahan saat menghapus')
      } finally {
        this.loading = false
        this.bulkDeleteDialog = false
      }
    },

    // Ensures every Baru+manual row's catalog-duplicate status is fresh
    // before submit is allowed to proceed. Deliberately re-checks every
    // still-eligible row rather than only ones with a pending debounce
    // timer: validateForm()'s per-row validateItemCode() call resets
    // each row's manual error state to re-derive the required-field/
    // in-form-duplicate checks, which would silently erase an
    // already-resolved catalog result if we only flushed pending
    // timers. Also clears any leftover timers so they don't fire
    // redundantly afterwards.
    async flushPendingCatalogChecks() {
      Object.keys(this.catalogCheckTimers).forEach(key => {
        clearTimeout(this.catalogCheckTimers[key])
      })
      this.catalogCheckTimers = {}

      const checks = []
      this.form_data.forEach((row, index) => {
        if (
          row.is_new &&
          !row.generate_code &&
          row.manual &&
          !this.is_error.items[index].manual
        ) {
          checks.push(this.runCatalogCheck(index))
        }
      })

      await Promise.all(checks)
    },

    async validateForm() {
      let valid = true

      for (let i = 0; i < this.form_data.length; i++) {
        // Validate item code first
        if (!this.validateItemCode(i)) {
          valid = false
        }

        if (
          !this.form_data[i].category_selected ||
          typeof this.form_data[i].category_selected !== 'object'
        ) {
          valid = false
          this.is_error.items[i].cat_id = true
          this.error_msg.items[i].cat_id = 'Pilih kategori'

          setTimeout(() => {
            if (this.is_error.items[i].cat_id) {
              this.form_data[i].category_selected = ''
            }
          }, 2000)
        }

        if (!this.form_data[i].name) {
          valid = false
          this.is_error.items[i].name = true
          this.error_msg.items[i].name = 'Isi nama'
        }

        if (
          this.form_data[i].qty <= 0 ||
          this.form_data[i].qty === '0' ||
          this.form_data[i].qty === ''
        ) {
          valid = false
          this.is_error.items[i].qty = true
          this.error_msg.items[i].qty = 'Isi jumlah'
        }

        if (!this.form_data[i].price) {
          valid = false
          this.is_error.items[i].price = true
          this.error_msg.items[i].price = 'Isi harga'
        }
      }

      // Catalog-duplicate check is async/debounced during normal
      // typing — resolve it fully before letting submit proceed.
      await this.flushPendingCatalogChecks()

      this.form_data.forEach((row, i) => {
        if (this.is_error.items[i] && this.is_error.items[i].manual) {
          valid = false
        }
      })

      return valid
    },

    /**
     * Calculate total price for an item
     * @param {number} index - Index of the item in form_data array
     */
    calculatePrice(index = 0) {
      // Validate index
      if (index == null || index === '' || index < 0) {
        return
      }

      const item = this.form_data[index]
      if (!item) {
        return
      }

      // Get values (already updated by v-model via @input event)
      const price = Number(item.price) || 0
      const qty = Number(item.qty) || 0

      // Calculate total price only (don't reassign price to avoid reset)
      item.total_price = price * qty

      // Update total price and quantity using computed properties
      this.total_price = this.totalPrice
      this.total_qty = this.totalQuantity
    },

    calculateEditPrice(item) {
      if (item) {
        const priceValue = String(item.price).replace(/\./g, '')
        const parsedPrice = parseInt(priceValue, 10)
        const index = this.purchase_orders.findIndex(i => i.id === item.id)

        if (!isNaN(parsedPrice) && index !== -1) {
          this.purchase_orders[index].price = parsedPrice
        }
      }

      // Update total price and quantity using computed properties
      this.total_price = this.editModeTotalPrice
      this.total_qty = this.editModeTotalQuantity
    },

    /**
     * Truncate text to specified length and add ellipsis
     * @param {string} text - Text to truncate
     * @param {number} maxLength - Maximum length before truncation
     * @returns {string} Truncated text with ellipsis
     */
    truncateText(text, maxLength) {
      if (!text) return '-'
      if (text.length <= maxLength) return text
      return text.substring(0, maxLength) + '...'
    },

    addRow() {
      this.form_data.push({
        generate_code: true,
        generate_category: false,
        item_selected: null,
        is_new: true,
        category_selected: null,
        name: '',
        qty: null,
        price: null,
        price_per_item: null,
        total_price: null,
        manual: null
      })

      this.is_error.items.push({
        code: false,
        cat_id: false,
        name: false,
        qty: false,
        price: false,
        manual: false
      })

      this.error_msg.items.push({
        code: '',
        cat_id: '',
        name: '',
        qty: '',
        price: '',
        manual: ''
      })
    },

    deleteRow(idx) {
      this.form_data.splice(idx, 1)
      this.is_error.items.splice(idx, 1)
      this.error_msg.items.splice(idx, 1)
      this.form_edit = 0

      // Every pending catalog-check timer is keyed by row index; this
      // splice shifts every subsequent row's index, so a timer left
      // pending here would apply its eventual result to whatever row
      // now occupies that index. Clearing all of them (rather than
      // trying to re-key the survivors) is the simple, correct fix —
      // the cost is that any other row's in-flight check has to be
      // re-triggered by the user touching that field again.
      Object.keys(this.catalogCheckTimers).forEach(key => {
        clearTimeout(this.catalogCheckTimers[key])
      })
      this.catalogCheckTimers = {}

      this.calculatePrice()
    },

    clearData() {
      this.loading = false
      this.total_qty = 0
      this.total_price = 0

      this.form_data = [
        {
          generate_code: true,
          item_selected: null,
          is_new: true,
          category_selected: null,
          name: '',
          qty: null,
          price: null
        }
      ]

      this.create_data = {
        doc_number: '',
        doc_date: '',
        sup_id: 0,
        confirmed: false,
        items: [
          {
            code: '',
            cat_id: 0,
            name: '',
            qty: null,
            price: null
          }
        ]
      }

      this.is_error = {
        items: [
          {
            code: false,
            cat_id: false,
            name: false,
            qty: false,
            price: false
          }
        ]
      }

      this.error_msg = {
        items: [
          {
            code: '',
            cat_id: '',
            name: '',
            qty: '',
            price: ''
          }
        ]
      }

      this.prepareItemsToAdd()
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-edit {
  .card {
    margin-top: 1rem !important;
    padding: 1rem !important;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2),
      0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);

    .card-header {
      border-bottom: 1px solid #dee2e6;
      margin-bottom: 1rem;

      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 100%;
        margin: 0 auto;

        .card-title {
          margin: 0;
          font-size: 1.5rem;
          font-weight: 600;
          color: #495057;
        }
      }
    }

    .card-body {
      max-width: 100%;
      margin: 0 auto;
      overflow: hidden;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 0.75rem;
      background-color: #f8f9fa;
      border-radius: 4px;
      padding: 1rem;
      margin-bottom: 1rem;

      .info-item {
        label {
          display: block;
          font-size: 0.875rem;
          color: #6c757d;
          margin-bottom: 0.25rem;
        }

        div {
          font-size: 0.875rem;
          color: #212529;
        }
      }
    }
  }

  // Add compact DataTable styles
  :deep(.p-datatable) {
    .p-datatable-header {
      padding: 0.5rem;
    }

    .p-datatable-thead > tr > th {
      padding: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.2;

      // Column widths
      &:nth-child(1) {
        width: 3rem;
      } // Selection
      &:nth-child(2) {
        width: 3rem;
      } // No
      &:nth-child(3) {
        width: 8rem;
      } // Kode Barang
      &:nth-child(4) {
        width: 12.5rem;
      } // Nama Barang
      &:nth-child(5) {
        width: 12.5rem;
      } // Kategori (merged Kode - Nama)
      &:nth-child(6) {
        width: 8rem;
      } // HM
      &:nth-child(7) {
        width: 4rem;
      } // Qty
      &:nth-child(8) {
        width: 8rem;
      } // Total
      &:nth-child(9) {
        width: 6rem;
      } // Actions
    }

    .p-datatable-tbody > tr > td {
      padding: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.2;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      // Allow overflow for cells containing dropdowns
      &:has(.category-dropdown-zfix) {
        overflow: visible !important;
        position: relative;
        z-index: 10;
      }

      // Column widths matching headers
      &:nth-child(1) {
        width: 3rem;
      } // Selection
      &:nth-child(2) {
        width: 3rem;
      } // No
      &:nth-child(3) {
        width: 8rem;
      } // Kode Barang
      &:nth-child(4) {
        width: 12.5rem;
      } // Nama Barang
      &:nth-child(5) {
        width: 12.5rem;
      } // Kategori (merged Kode - Nama)
      &:nth-child(6) {
        width: 8rem;
      } // HM
      &:nth-child(7) {
        width: 4rem;
      } // Qty
      &:nth-child(8) {
        width: 8rem;
      } // Total
      &:nth-child(9) {
        width: 6rem;
      } // Actions
    }

    .p-datatable-tbody > tr {
      &:hover {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .p-button-sm {
      padding: 0.25rem;
      font-size: 0.875rem;
    }

    .p-paginator {
      padding: 0.5rem;
    }
  }

  // Global fix for autocomplete panel z-index in DataTable
  :deep(.category-dropdown-zfix) {
    .p-autocomplete-panel {
      z-index: 1200 !important;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.75rem;
    margin-bottom: 1.5rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;

    .info-item {
      label {
        display: block;
        font-size: 0.75rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
      }

      div {
        font-size: 0.875rem;
        color: #495057;
        font-weight: 500;
      }
    }

    // Responsive: 2 columns on medium screens, 1 column on small screens
    @media screen and (max-width: 960px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (max-width: 640px) {
      grid-template-columns: 1fr;
    }
  }

  // Reduce bottom spacing
  .p-grid {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    gap: 0.5rem;
  }

  .p-col-12 {
    margin-bottom: 0;
  }

  .p-dialog {
    .p-dialog-content {
      padding: 1rem;
    }

    .p-dialog-footer {
      padding: 0.5rem;
    }
  }

  .confirmation-content {
    padding: 0.5rem 0;
  }

  .flexp-d-flex {
    padding: 0.25rem;
  }
}

// Add loading overlay styles
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

// Add transition effects
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// Improve table styles
.table {
  width: 100%;
  min-width: 85rem;
  border-collapse: collapse;
  margin-bottom: 1rem;

  th,
  td {
    padding: 0.5rem;
    border: 1px solid #dee2e6;
    white-space: nowrap;
  }

  th {
    background-color: #f8f9fa;
    font-weight: 600;
    text-align: left;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  td {
    vertical-align: middle;
  }

  // Remove the width: 100% from these since we're setting explicit widths
  .p-inputtext,
  .p-autocomplete,
  .p-inputnumber,
  .p-checkbox {
    display: block;
  }

  .p-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.75rem;
  }

  :deep(.p-inputnumber) {
    width: 8rem;

    .p-inputtext {
      width: 100%;
    }
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 !important;
  padding: 0 !important;
}

// Add button loading state
.btn-loading {
  position: relative;
  pointer-events: none;
  opacity: 0.8;

  .spinner {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
  }
}

// Add form feedback styles
.form-feedback {
  margin-top: 0.25rem;
  font-size: 0.875rem;

  &.error {
    color: #dc3545;
  }

  &.success {
    color: #28a745;
  }
}

// Add input focus styles
input:focus,
textarea:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
  outline: none;
}

// Add disabled state styles
.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.p-button-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

:deep(.item-autocomplete) {
  width: 11rem;
  .p-autocomplete-input {
    width: calc(100% - 2rem);
  }
}

:deep(.category-autocomplete) {
  width: 9rem;

  .p-autocomplete-input {
    width: calc(100% - 2rem);
  }
}

:deep(.p-datatable) {
  .p-datatable-tbody > tr > td {
    // Add specific styles for InputNumber in table
    .p-inputnumber {
      width: 100% !important;
      .p-inputtext {
        width: 100% !important;
      }
    }
  }
}

// Add specific styles for InputNumber components
:deep(.p-inputnumber) {
  width: 100% !important;
  position: relative;
  .p-inputtext {
    width: 100% !important;
  }
  .p-inputnumber-button {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
  }
}
</style>
